import * as React from 'react';
import styled from 'styled-components';
import { truncate } from '../utils';
import { ItemWithSelection } from './ItemWithSelection';
const defaultColor = '#424d57';
const Arrow = styled.span `
  // color: ${defaultColor} !default;
  font-size: 0.5em;
  opacity: 0.6;
  width: 20px;
`;
const NextArrow = styled(Arrow) `
  text-align: right;
`;
// const Label = withProps<LabelProps, HTMLSpanElement>(styled.span)`
const Label = styled.span `
  ${(props) => truncate(props.width || '200px')}
  flex-grow: 1;
`;
const Counter = styled.span `
  opacity: 0.6;
  width: 20px;
`;
class Item extends React.Component {
    constructor() {
        super(...arguments);
        this.element = null;
        this.ref = (element) => {
            this.element = element;
        };
    }
    componentWillReceiveProps(next) {
        const { element } = this;
        const { focused } = next;
        if (!focused || !element) {
            return;
        }
        const options = {
            block: 'nearest',
            inline: 'nearest'
        };
        // if (element.scrollIntoViewIfNeeded) {
        //   element.scrollIntoViewIfNeeded(options);
        // } else {
        //   element.scrollIntoView(options);
        // }
        element.scrollIntoView(options);
    }
    render() {
        const { className, label, next, prev, width, onPrev } = this.props;
        const hasNext = Array.isArray(next) && next.length !== 0;
        const onClick = (event) => {
            event.stopPropagation();
            if (!onPrev) {
                return;
            }
            onPrev();
        };
        return (React.createElement("div", { ref: this.ref, className: className },
            prev && React.createElement(Arrow, { onClick: onClick }, "\u25C4"),
            hasNext && React.createElement(Counter, null, next.length),
            React.createElement(Label, { width: width }, label),
            hasNext && React.createElement(NextArrow, null, "\u25BA")));
    }
}
Item.defaultProps = { width: '200px' }; // todo
const StyledItem = styled(Item) `
  background-color: ${(props) => (props.focused ? '#51b651' : 'white')};

  color: ${(props) => (props.focused ? 'white' : 'black')};

  cursor: pointer;
  line-height: 20px;
  max-width: ${(props) => props.width};
  min-height: 20px;
  padding: 0 10px;

  display: flex;
  justify-content: space-around;
`;
export const HashHintItem = ItemWithSelection(StyledItem);
//# sourceMappingURL=HashHintItem.js.map